export enum CloseDialogModalEnum {
    OK = 'ok',
    CANCEL = 'cancel'
}